function change_action(path){
  let school_report_form = $("#school_report_form")
  school_report_form.prop("action", path);
  // school_report_form.submit();
}
